




















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class AddNewsModal extends Vue {
    // local
    newsTypes = ["text", "image", "video"]

    // methods
    open() {
        this.$bvModal.show("modal-addNews");
    }

    selectNewsType(newsType: string) {
        this.$router.push({
            name: "CreateNews",
            params: {
                newsType: newsType
            }
        });
    }
}
